import type { IncomingCall } from "@notifications/incomingCallStore";
import { formatPhoneNumber } from "@phone/phoneSetupClient";

/** Shared so every surface names a caller the same; `clientName` is omitted because the inbound slip never shows it. */
export const inboundCallerName = (
  call: Pick<IncomingCall, "callerName" | "label" | "fromNumber">,
): string | null =>
  call.callerName ??
  call.label ??
  (call.fromNumber ? formatPhoneNumber(call.fromNumber) : null);
